import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfigService } from './config.service';
import { ApiResponse } from '../shared/models';

export interface GlobalSearchResultItem {
  moduleKey: string;
  moduleId: number;
  moduleLabel: string;
  icon: string;
  entityId: string;
  title: string;
  subTitle?: string;
  route: string;
  badge?: string;
  badgeClass?: string;
}

export interface GlobalSearchGroup {
  moduleKey: string;
  moduleId: number;
  moduleLabel: string;
  icon: string;
  total: number;
  items: GlobalSearchResultItem[];
}

export interface GlobalSearchResult {
  query: string;
  totalHits: number;
  groups: GlobalSearchGroup[];
}

@Injectable({
  providedIn: 'root'
})
export class GlobalSearchService {
  private get apiUrl(): string {
    return `${this.configService.get('apiBaseUrl')}/Search`;
  }

  constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) {}

  search(query: string, maxPerModule = 5): Observable<ApiResponse<GlobalSearchResult>> {
    const params = new HttpParams()
      .set('query', query)
      .set('maxPerModule', String(maxPerModule));

    return this.http
      .get<ApiResponse<GlobalSearchResult>>(`${this.apiUrl}/Global`, { params })
      .pipe(map((response) => response));
  }
}
